var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 5,
    fill: "#35C7FF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 6.66675C11.417 6.66675 7.66699 10.4167 7.66699 15.0001C7.66699 19.5834 11.417 23.3334 16.0003 23.3334C20.5837 23.3334 24.3337 19.5834 24.3337 15.0001C24.3337 10.4167 20.5837 6.66675 16.0003 6.66675ZM19.5003 13.5834L15.5003 17.5834C15.167 17.9167 14.667 17.9167 14.3337 17.5834L12.5003 15.7501C12.167 15.4167 12.167 14.9167 12.5003 14.5834C12.8337 14.2501 13.3337 14.2501 13.667 14.5834L14.917 15.8334L18.3337 12.4167C18.667 12.0834 19.167 12.0834 19.5003 12.4167C19.8337 12.7501 19.8337 13.2501 19.5003 13.5834Z",
    fill: "#35C7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.bbf56c5ad45b8cd927ff4af689d86a7f.svg";
export { ForwardRef as ReactComponent };